import { create } from 'zustand'

export type HelpView = 'help' | 'tickets'

interface OpenOptions {
  question?: string
  slug?: string
}

interface HelpStoreActions {
  open: (options?: OpenOptions) => void
  openTickets: (ticketId?: string) => void
  close: () => void
  setView: (view: HelpView) => void
  consumeSeed: () => void
  consumeInitialTicket: () => void
}

interface HelpStore {
  isOpen: boolean
  view: HelpView
  seedQuestion: string | null
  initialSlug: string | null
  initialTicketId: string | null
  actions: HelpStoreActions
}

const useHelpStore = create<HelpStore>((set) => ({
  isOpen: false,
  view: 'help',
  seedQuestion: null,
  initialSlug: null,
  initialTicketId: null,
  actions: {
    open: (options) =>
      set({
        isOpen: true,
        view: 'help',
        seedQuestion: options?.question ?? null,
        initialSlug: options?.slug ?? null,
      }),
    openTickets: (ticketId) =>
      set({
        isOpen: true,
        view: 'tickets',
        initialTicketId: ticketId ?? null,
      }),
    close: () => set({ isOpen: false }),
    setView: (view) => set({ view }),
    consumeSeed: () => set({ seedQuestion: null, initialSlug: null }),
    consumeInitialTicket: () => set({ initialTicketId: null }),
  },
}))

export const useHelpIsOpen = () => useHelpStore((state) => state.isOpen)
export const useHelpView = () => useHelpStore((state) => state.view)
export const useHelpSeedQuestion = () =>
  useHelpStore((state) => state.seedQuestion)
export const useHelpInitialSlug = () =>
  useHelpStore((state) => state.initialSlug)
export const useHelpInitialTicketId = () =>
  useHelpStore((state) => state.initialTicketId)
export const useHelpActions = () => useHelpStore((state) => state.actions)

// For non-React callers (the support SSE handler checks thread visibility).
export const getHelpState = () => useHelpStore.getState()
